module.exports = __webpack_public_path__ + "img/logo-locker-company-neg.6ddaa3b4.svg";